export const GET_ASSOCIATE_DATA_SUCCESS = "GET_ASSOCIATE_DATA_SUCCESS";
export const DOWNLOAD_PROFILE_PICTURE_SUCCESS = "DOWNLOAD_PROFILE_PICTURE_SUCCESS";
export const GET_ACTION_LOG_SUCCESS = "GET_ACTION_LOG_SUCCESS";
export const SET_EDIT_MODE = "SET_EDIT_MODE";
export const CHANGE_APP_LANGUAGE = "CHANGE_APP_LANGUAGE";